import StyleSheet from 'react-native-extended-stylesheet';

export const styles = StyleSheet.create({
  layout: {
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: '$space12',
  },
  textContainer: {
    marginVertical: '$space12',
  },
  title: {
    textAlign: 'center',
    marginBottom: '$space6',
  },
  subtitle: {
    textAlign: 'center',
    marginHorizontal: '$space12',
  },
  actionsL: {
    marginTop: '$space12',
  },
});
